import { createContext, useContext } from 'react';

import type { SymbolKey } from '@/entities/symbol';

export type FactsheetSelectionState = {
  isSymbolSelected: (symbol: SymbolKey) => boolean;
  toggleSymbolInSelection: (symbol: SymbolKey) => void;
  addSymbolsToSelection: (symbols: SymbolKey[]) => void;
  removeSymbolsFromSelection: (symbols: SymbolKey[]) => void;
  areAllSymbolsSelected: (symbols: SymbolKey[]) => boolean;
  isSpotLocked: boolean;
};

export const FactsheetSelectionContext = createContext<FactsheetSelectionState | null>(null);

export const useFactsheetSelection = () => useContext(FactsheetSelectionContext);
